import React, { useEffect, useMemo, useState } from 'react'
import { Wrapper, Card, AvatarProfile } from '../../_components'
import Table from '../../_components/Table'
import { capitalize } from '../../_utils'
import Axios from 'axios'
import moment from 'moment'

const NameField = record => {
    let Name = record.value?.split(" ")

    return (
        <div className="flex flex-col items-start justify-center">
            <AvatarProfile bold label={`${capitalize( Name[ 0 ] )} ${capitalize( Name[ 1 ] )}`}/>
        </div>
    )
}

const StatusField = record => {
    return (
        <div>{`Status`}</div>
    )
}

export default function AllSMS() {

    const smsColumns = useMemo(
     () => [
        {
            Header: "Farmer Name",
            accessor: "name",
            sortable: false,
            filterable: false,
            Cell: NameField
        },
        {
            Header: "Registation No.",
            accessor: "farmer_code"
        },
        {
            Header: "Farmer Phone Number",
            accessor: "phone"
        },
        {
            Header: "Message",
            accessor: "message"
        },
        {
            Header: "Message",
            accessor: "message_status"
        },
        {
            Header: "Date Sent",
            accessor: "date"
        },
        ]
    )

    const [ records, setRecords ] = useState( [] )
    const [ loading, setLoading ] = useState( true )

    useEffect( () => {
        if( loading ) {
          fetchAllSMS()
        }
    },[ loading ])

    const fetchAllSMS = async() => {
        try {
            const response = await Axios.get( `https://mis.nec.go.ug/api/auth/fiefoc_all_sms/${localStorage.getItem( "scheme" )}` )
            if( response.data ) {
                const results = response.data?.data.map( result => {
                    return {
                        name: result.farmer_name,
                        phone: result.farmer_phone,
                        farmer_code: result.farmer_code,
                        farmer_category: result.farmer_category,
                        date: moment( result.created_at ).format( "DD MMM, YYYY" ),
                        message: result.message,
                        message_status: result.message_status === "SUBMITTED" ? "Successful" : "Failed",
                        created_by: result.created_by
                    }
                } )

                setRecords( results )
                setLoading( false )
            }
        } catch (error) {
            
        }
    }
    
    return (
    <Wrapper>
     <div className="flex flex-col">
        <h2 className="md:text-lg lg:text-lg text-sm py-2">
            {`View All Sent SMS`}
        </h2>
        <Card title="All SMS Messages sent">
         <Table
            label="All SMS"
            columns={smsColumns}
            data={records}
            hidePagination={false}
        />
        </Card>
     </div>
    </Wrapper>
  )
}
